import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_BASKET = gql`
  query campaignOrderTransactionsBasket(
    $where: CampaignOrderTransactionsWithEventsWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionsWithEventsOrderByInput
  ) {
    campaignOrderTransactionsWithEventsesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          orderId
          basketItems {
            id
            name
            quantity
            price
            total
          }
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrderTransactionsWithEventsesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_BASKET;
